import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TroubleshootingPage = () => {
        const navigate = useNavigate();
        const location = useLocation();
        const roomId = location.state?.roomId;

        const handleRetry = () => {
                navigate(-1);
        };

        return (
                <div className="page-gradient min-h-screen">
                        <Header />

                        <main className="max-w-7xl mx-auto px-4 sm:px-8 py-8">
                                <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-lg p-8">
                                        <div className="text-center mb-8">
                                                <h2 className="text-3xl font-bold text-gray-900 mb-2">Troubleshooting Device Pairing</h2>
                                                <p className="text-gray-600">
                                                        We couldn't connect to your device. Please review the common issues below.
                                                </p>
                                        </div>

                                        <div className="space-y-6">
                                                {/* Common Problem 1 */}
                                                <div className="border-l-4 border-blue-500 bg-blue-50 p-6 rounded-r-lg">
                                                        <h3 className="text-lg font-semibold text-gray-900 mb-3 flex items-center">
                                                                <span className="bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 flex-shrink-0">
                                                                        1
                                                                </span>
                                                                Incorrect Wi-Fi Password
                                                        </h3>
                                                        <p className="text-gray-700 mb-3">
                                                                If the device cannot join the chosen Wi-Fi network, it will display a <span className="font-semibold text-red-600">solid red light</span> for about 1 minute, indicating an error.
                                                        </p>
                                                        <p className="text-gray-700">
                                                                The device will then return to pairing mode (<span className="font-semibold text-blue-600">blinking blue</span>). Double-check your Wi-Fi password and try again.
                                                        </p>
                                                </div>

                                                {/* Common Problem 2 */}
                                                <div className="border-l-4 border-blue-500 bg-blue-50 p-6 rounded-r-lg">
                                                        <h3 className="text-lg font-semibold text-gray-900 mb-3 flex items-center">
                                                                <span className="bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 flex-shrink-0">
                                                                        2
                                                                </span>
                                                                Device Not in Pairing Mode
                                                        </h3>
                                                        <p className="text-gray-700 mb-3">
                                                                Ensure your CleverPlant device is in pairing mode before attempting to connect.
                                                        </p>
                                                        <p className="text-gray-700">
                                                                To set the device in pairing mode, hold the button on the device for 10 seconds. The device will <span className="font-semibold text-blue-600">blink blue</span> when ready.
                                                        </p>
                                                </div>
                                        </div>

                                        <div className="mt-8 flex justify-center gap-4">
                                                <button
                                                        onClick={handleRetry}
                                                        className="bg-blue-500 hover:bg-blue-600 text-white px-8 py-3 rounded font-medium text-lg transition-colors"
                                                >
                                                        Go to dashboard
                                                </button>
                                        </div>

                                        <div className="mt-8 text-center text-sm text-gray-500">
                                                <p>Still having trouble? Contact support for assistance.</p>
                                        </div>
                                </div>
                        </main>

                        <Footer />
                </div>
        );
};

export default TroubleshootingPage;
